import React from 'react';
import { Link } from 'react-router-dom';
import { SETTINGS_DISPLAY_ITEMS, SETTINGS_GROUPS } from '../config/settingsNav';

/** Hub page: links to all configuration sections (see Layout sidebar Settings entry). */
const Settings = () => {
  const sections = SETTINGS_GROUPS.map((group) => ({
    ...group,
    items: SETTINGS_DISPLAY_ITEMS.filter((item) => item.group === group.key),
  })).filter((section) => section.items.length > 0);

  return (
    <div className="settings-hub">
      <div className="settings-hub-intro">
        <h2 className="settings-hub-title">Configuration</h2>
        <p className="settings-hub-lead">
          Storefront behavior, app policies, and integrations. Pick a section below.
        </p>
      </div>

      {sections.map((section) => (
        <section key={section.key} className="settings-hub-section">
          <h3 className="settings-hub-section-title">{section.label}</h3>
          <div className="settings-hub-grid">
            {section.items.map((item) => (
              <Link key={item.path} to={item.path} className="settings-hub-card">
                <span className="settings-hub-card-icon" aria-hidden>
                  {item.icon}
                </span>
                <span className="settings-hub-card-label">{item.label}</span>
                <span className="settings-hub-card-desc">{item.description}</span>
                <span className="settings-hub-card-arrow" aria-hidden>
                  →
                </span>
              </Link>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};

export default Settings;
